<template>
  <div>
    <Head title="Users" />
    <h1 class="mb-8 text-3xl font-bold">Users</h1>
    <div class="mb-6 flex items-center justify-between gap-4">
      <div class="flex flex-1 items-center gap-4">
        <select
          id="status-filter"
          v-model="form.status"
          class="form-select max-w-40"
        >
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="all">All</option>
          <option value="trashed">Trashed</option>
        </select>
        <search-filter
          v-model="form.search"
          class="w-full max-w-md"
          @reset="reset"
        />
      </div>
      <Link v-if="can.create_user" class="btn-teal" :href="$routes.new_user()">
        Create <span class="hidden md:inline">User</span>
      </Link>
    </div>
    <div class="overflow-x-auto rounded-sm bg-white shadow-sm">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="px-6 pb-4 pt-6">Nume</th>
            <th class="px-6 pb-4 pt-6">Email</th>
            <th class="px-6 pb-4 pt-6">Companie</th>
            <th class="px-6 pb-4 pt-6" colspan="2">Ultima activitate</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in users"
            :key="user.id"
            class="focus-within:bg-gray-100 hover:bg-gray-100"
          >
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4 focus:text-indigo-500"
                :href="$routes.user(user.id)"
                aria-label="Edit"
              >
                {{ user.name }}
                <icon
                  v-if="user.deleted_at"
                  name="trash"
                  class="ml-2 h-3 w-3 shrink-0 fill-red-500"
                />
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="$routes.user(user.id)"
                tabindex="-1"
                aria-label="Edit"
              >
                {{ user.email }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="$routes.user(user.id)"
                tabindex="-1"
                aria-label="Edit"
              >
                {{ user.company }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="$routes.user(user.id)"
                tabindex="-1"
                aria-label="Edit"
              >
                {{ formatDateTime(user.last_activity) }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link
                class="flex items-center px-4"
                :href="$routes.user(user.id)"
                tabindex="-1"
                aria-label="Edit"
              >
                <icon
                  name="cheveron-right"
                  class="block h-6 w-6 fill-gray-500"
                />
              </Link>
            </td>
          </tr>
          <tr v-if="users.length === 0">
            <td class="border-t px-6 py-4" colspan="6">No users found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Icon from '@/Shared/Icon.vue';
import Layout from '@/Layouts/Main.vue';
import mapValues from 'lodash/mapValues';
import pickBy from 'lodash/pickBy';
import SearchFilter from '@/Shared/SearchFilter.vue';
import throttle from 'lodash/throttle';
import { formatDateTime } from '@/utils/formatters';

export default {
  components: {
    Head,
    Link,
    Icon,
    SearchFilter,
  },
  layout: Layout,
  props: {
    users: {
      type: Array,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    can: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role: this.filters.role,
        status: this.filters.status || 'active',
      },
    };
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form);
        this.$inertia.get(
          this.$routes.users(
            Object.keys(query).length ? query : { remember: 'forget' },
          ),
          {},
          {
            preserveState: true,
            preserveScroll: true,
            replace: true,
            only: ['users'],
          },
        );
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = {
        ...mapValues(this.form, () => null),
        status: 'active',
      };
    },
    formatDateTime,
  },
};
</script>
